module.exports = "<div class=\"canvas-container\" #canvasContainer>\n<canvas #speedCanvas>\n</canvas>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/speedometer/speedometer.component.html
// module id = ./src/app/modules/shared/components/speedometer/speedometer.component.html
// module chunks = main